import { render, staticRenderFns } from "./ResourceOntologyPage.html?vue&type=template&id=5c4cda89&"
import script from "./ResourceOntologyPage.js?vue&type=script&lang=js&"
export * from "./ResourceOntologyPage.js?vue&type=script&lang=js&"
import style0 from "./ResourceOntologyPage.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports